import { createConsumer } from '@rails/actioncable';
function isConsumer(object) {
  if (object) {
    try {
      return object.constructor.name === 'Consumer' && object.connect && object.disconnect && object.send;
    } catch (e) {}
  }
  return false;
}
function findConsumer(object) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!object) return null;
  if (depth > 3) return null;
  if (isConsumer(object)) return object;
  return Object.values(object).map(function (o) {
    return findConsumer(o, depth + 1);
  }).find(function (o) {
    return o;
  });
}
export function getConsumer() {
  return findConsumer(window) || createConsumer();
}